module.exports = __webpack_public_path__ + "img/scotts.eadca838.jpg";